{
  "name": "jimeng-cli",
  "version": "0.3.9",
  "description": "即梦/CapCut 图像与视频生成 CLI 与 MCP 工具",
  "type": "module",
  "main": "dist/index.cjs",
  "bin": {
    "jimeng-cli": "dist/cli/index.js",
    "jimeng": "dist/cli/index.js",
    "jimeng-mcp": "dist/mcp/index.js"
  },
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist/"
  ],
  "scripts": {
    "prepublishOnly": "npm run build",
    "dev": "tsup --watch",
    "start": "node --enable-source-maps --no-node-snapshot dist/index.js",
    "build": "tsup",
    "mcp:dev": "tsup --entry src/mcp/index.ts --watch --onSuccess \"node --enable-source-maps --no-node-snapshot dist/mcp/index.js\"",
    "mcp:start": "node --enable-source-maps --no-node-snapshot dist/mcp/index.js",
    "mcp:smoke": "npm run build && node scripts/mcp-smoke.mjs",
    "test": "npm run mcp:smoke && npm run cli:smoke",
    "format": "prettier --write \"src/**/*.{ts,js,json}\"",
    "type-check": "tsc --noEmit",
    "token:check": "node --enable-source-maps --no-node-snapshot dist/cli/index.js token check",
    "cli:smoke": "npm run build && node scripts/cli-smoke.mjs"
  },
  "author": "Jimeng CLI Team",
  "license": "GPL-3.0",
  "keywords": [
    "ai",
    "image-generation",
    "video-generation",
    "openai-compatible",
    "jimeng",
    "api"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/Algovate/jimeng-cli.git"
  },
  "bugs": {
    "url": "https://github.com/Algovate/jimeng-cli/issues"
  },
  "homepage": "https://github.com/Algovate/jimeng-cli",
  "engines": {
    "node": ">=18.0.0"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.27.0",
    "axios": "^1.6.7",
    "date-fns": "^3.3.1",
    "fs-extra": "^11.2.0",
    "https-proxy-agent": "^7.0.6",
    "mime": "^4.0.1",
    "minimist": "^1.2.8",
    "picocolors": "^1.1.1",
    "socks-proxy-agent": "^8.0.5",
    "uuid": "^9.0.1",
    "yaml": "^2.3.4",
    "zod": "^4.3.6"
  },
  "devDependencies": {
    "@types/fs-extra": "^11.0.4",
    "@types/minimist": "^1.2.5",
    "@types/node": "^20.11.0",
    "@types/uuid": "^9.0.7",
    "prettier": "^3.6.2",
    "tsup": "^8.0.2",
    "typescript": "^5.3.3"
  }
}
